import { Injector } from "@angular/core";
import { MareAuthService } from "@mare-common/ngx-mare-auth";
import { ErrorHandlerService } from "@mare-common/ngx-mare-common";
import { PlatformApiWPublicService } from "./platform-apiwp-public.service";
import { PlatformApiWpService } from "./platform-apiwp.service";
import { TokenService } from "./token.service";
import { lastValueFrom, Subject } from "rxjs";
import { RoutingService } from "./routing.service";
import { ActivatedRoute, Router } from "@angular/router";
import { environment } from "src/environments/environment";

export abstract class DoubleService {

    protected platformApiWpService!: PlatformApiWPublicService | PlatformApiWpService;
    doubleServiceIsInit: boolean = false;
    doubleServiceIsInit$ = new Subject<boolean>();

    protected routingService = this.injector.get(RoutingService);
    protected route = this.injector.get(ActivatedRoute)
    protected router = this.injector.get(Router);
    token: any;
    isToActivate: boolean = false;
  constructor(
    protected authService: MareAuthService,
    protected tokenService: TokenService,
    protected injector: Injector

  ) {
    
    this.authService.isLogged();
    if (this.tokenService.isInit) {
      this.__doubleServiceInit();
    } else {
      let subscription = this.tokenService.isInit$.subscribe((res) => {
        if (res) {
          subscription.unsubscribe();
          this.__doubleServiceInit();
        }
      })
    }
  }

  setIsToActivate(isToActivate: boolean) {
    this.isToActivate = isToActivate;
  }

  __doubleServiceInit() {
    if (this.authService.isLogged()) {
      this.platformApiWpService = this.injector.get(PlatformApiWpService);
    } else {
      this.platformApiWpService = this.injector.get(PlatformApiWPublicService);
      this.token = this.route.snapshot.queryParams['token'];
      // this.route.queryParams.subscribe(params => {
      //   if(params['token']) {
      //     this.token = params['token'];
      //   }
      // });
    }
    this.doubleServiceIsInit = true;
    this.doubleServiceIsInit$.next(true);
  }

  activateUser(): Promise<any> {
    return new Promise(async (resolve, reject) => {
      if (!this.doubleServiceIsInit) {
        await lastValueFrom(this.doubleServiceIsInit$);
      }
      // this.platformApiWpService.getRequest('/msc/v1/company/activate?token='+token).then((sub: any) => {
      this.platformApiWpService.getRequest('/msc/v1/company/activate').then((sub: any) => {
        sub.subscribe((res: any) => {
          console.log(res);
          if (res && res.status == 'ok') {
            resolve(res.payload);
          } else {
            reject(false);
          }
          // console.log(res.payload);
        })

      }, (err: any) => {
        reject(err)
      })
    })
  }

  /**
   * Redirects to the given platform page, either by opening a new tab (if the user is already logged in)
   * or by activating and logging in the user first (if the user is not logged in).
   * @param string The platform key to redirect to.
   */
  async goToPlatform(platform: string, params?: any) {
    let url: any = '/maresso?platform=' + platform;
    if(params) {
      for (const key in params) {
        if (Object.prototype.hasOwnProperty.call(params, key)) {
          url += '&' + key + '=' + params[key];
        }
      }
    }
    const urlToTeridrect = this.routingService.checkRoute(url)
    if(!urlToTeridrect || !urlToTeridrect.url) {
      console.error('url not found');
      return
    }
    if(!this.authService.isLogged()) {
      await this.activateAndLogin(urlToTeridrect.url)
    } else {
      window.open(urlToTeridrect.url, '_blank');
    }
  }

  /**
   * Activates the user and logs him in, then redirects to the given url.
   * If the user is already activated, it only logs him in.
   * @param url The url to redirect to after activation/login.
   */
  async activateAndLogin(url: string) {
    if (!this.token)
    {
      console.error('token not found');
      return
    }
    // let isToActivate = this.kpiUserInfo && this.kpiUserInfo.to_create_user ? this.kpiUserInfo.to_create_user : false;
    // if (this.isToActivate) {
    //   await this.activateUser().catch((err: any) => {
    //     console.error(err);
    //   });
    // } 
    // this.router.navigate([environment.routingBasePath + '/login'], { queryParams: { delfi_token: this.token, redirect_uri:url  } });
    this.router.navigate([environment.routingBasePath + '/registration'], { queryParams: { token: this.token, redirect_uri:url  } });
  }

  /**
   * Logs in the user and then redirects to the cart with the given sku as param.
   * If the user is already logged in, it only redirects to the cart.
   * @param sku The sku of the product to add to the cart.
   */
 async loginAndBuy(sku: string, variationSku?: string) {
  // let url = window.location.origin.indexOf('localhost') > -1 ? 'https://servicecompany.maredigital.it'+ environment.routingBasePath+'/cart?sku=' + sku  : window.location.origin + environment.routingBasePath + '/cart?sku=' + sku
  let url = window.location.origin + '/' + environment.routingBasePath + '/cart?sku=' + sku;
  if(variationSku) {
    url = url + '&variationSku=' + variationSku
  }
  if (!this.authService.isLogged()) {
      await this.activateAndLogin(url)
    } else {
      this.router.navigate([environment.routingBasePath + '/cart'], { queryParams: { sku: sku, variationSku: variationSku } });
    }
  }
}
